import { FC } from 'react';

import { AvatarData } from '@/helpers/avatar';
import { getCDNImageUrl } from '@/helpers/cdn';

import { ScAvatar } from './styled';

export const Avatar: FC<AvatarData> = ({ src, alt, isSelected, ...props }) => (
  <ScAvatar
    src={src && getCDNImageUrl(src)}
    alt={alt}
    className={isSelected ? 'selected' : ''}
    {...props}
  />
);
